import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GoToStepDirective } from './go-to-step.directive';
import { NextStepDirective } from './next-step.directive';
import { PreviousStepDirective } from './previous-step.directive';
import { WizardComponent } from './wizard.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [WizardComponent, GoToStepDirective, NextStepDirective, PreviousStepDirective],
  exports: [WizardComponent, GoToStepDirective, NextStepDirective, PreviousStepDirective]
})
export class WizardModule { }
